const UPDATES = [
  {
    date: '07.28',
    tag: '上新',
    title: '韩漫《她的私密日记》第128话更新',
    desc: '剧情迎来重大转折，女主身份即将揭晓。',
  },
  {
    date: '07.27',
    tag: '热门',
    title: '日漫《夏日幻梦物语》第95话上线',
    desc: '夏日祭篇章进入高潮，情感线全面铺开。',
  },
  {
    date: '07.26',
    tag: '推荐',
    title: '国漫《长安幻夜行》新篇章开启',
    desc: '第三卷「长安夜未央」正式连载。',
  },
  {
    date: '07.25',
    tag: '上新',
    title: '悬疑漫《第七层密室》番外篇独家上线',
    desc: '揭秘主线中未公开的关键线索。',
  },
  {
    date: '07.24',
    tag: '公告',
    title: '谜妹漫画服务器全面升级完成',
    desc: '阅读加载速度提升50%，夜间模式同步上线。',
  },
  {
    date: '07.23',
    tag: '上新',
    title: '搞笑漫《废柴逆袭手册》突破500话',
    desc: '官方发布特别纪念篇，笑料加倍。',
  },
  {
    date: '07.22',
    tag: '热门',
    title: '恋爱漫画新作《星光咖啡馆》首话发布',
    desc: '新锐作者倾力打造，开篇即获9.2高分。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            每日更新资讯，精彩不重样
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-2 bottom-2 w-px bg-background-200"></div>

          <div className="space-y-5">
            {UPDATES.map((update, idx) => (
              <div key={idx} className="relative flex items-start gap-4 md:gap-5 pl-12 md:pl-14">
                <div className={`absolute left-4 md:left-[18px] w-2.5 h-2.5 md:w-3 md:h-3 rounded-full border-2 border-background-50 ${
                  idx === 0 ? 'bg-primary-500' : 'bg-background-300'
                }`}></div>

                <div className="flex-shrink-0">
                  <span className="text-xs md:text-sm font-medium text-foreground-400 whitespace-nowrap">
                    {update.date}
                  </span>
                </div>

                <div className="flex-1 min-w-0 bg-background-100 rounded-lg p-4 border border-background-200/60">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
                      update.tag === '上新'
                        ? 'bg-primary-100 text-primary-700'
                        : update.tag === '热门'
                        ? 'bg-accent-100 text-accent-700'
                        : update.tag === '推荐'
                        ? 'bg-secondary-100 text-secondary-700'
                        : 'bg-background-200 text-foreground-600'
                    }`}>
                      {update.tag}
                    </span>
                    <h3 className="font-medium text-sm md:text-base text-foreground-900">
                      {update.title}
                    </h3>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-500">
                    {update.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}